import DetailsBottom from './DetailsBottom.jsx';
import './DetailsBottom.css';

export default DetailsBottom;
